import type { DialogStep, TaskInfo, TaskState } from '~/types/interfaces'
import { useApiBase } from './useApiBase'

// #791 MR6: async workflow の task 状態 polling API。詳細は
// doc/architecture/async_workflows.md 参照。
//
// getTask() は abstract TaskState enum を返す — SFN state 名は絶対に leak しない
// (Fable Round 2 Q5)。terminal state (succeeded / publish_event_failed / failed)
// のとき onSuccess / onFailure DialogStep が populate される (Fable Round 5 Q18)。
export function useTaskApi() {
  const { apiBase, authenticatedFetch } = useApiBase()

  const getTask = async (taskId: string, locale: string = 'ja') => {
    return authenticatedFetch<TaskInfo>(
      `${apiBase}/api/v1/tasks/${encodeURIComponent(taskId)}?locale=${encodeURIComponent(locale)}`,
      { method: 'GET' },
    )
  }

  // E2E テスト専用 backdoor。production では 404 を返す (server 側で環境チェック)。
  // Fable Round 5 Q21: inline mode の debug_delay だけでは state 遷移順序を
  // deterministic に verify できないため。
  const forceTaskState = async (
    taskId: string,
    state: TaskState,
    options?: { onSuccess?: DialogStep, onFailure?: DialogStep, result?: object, error?: object },
  ) => {
    return authenticatedFetch<{ taskId: string, state: string }>(
      `${apiBase}/api/v1/tasks/${encodeURIComponent(taskId)}/_force_state`,
      {
        method: 'POST',
        body: JSON.stringify({
          state,
          onSuccess: options?.onSuccess ?? null,
          onFailure: options?.onFailure ?? null,
          result: options?.result ?? null,
          error: options?.error ?? null,
        }),
      },
    )
  }

  return { getTask, forceTaskState }
}
